import { forwardRef, useCallback, useImperativeHandle } from 'react';

export interface WebViewModalRef {
  open: (url: string) => void;
  close: () => void;
}

interface WebViewModalProps {
  onClose?: () => void;
}

const WebViewModal = forwardRef<WebViewModalRef, WebViewModalProps>(({ onClose }, ref) => {
  const open = useCallback(
    (url: string) => {
      // Open URL in new tab (web environment)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (globalThis as any).open?.(url, '_blank');
      onClose?.();
    },
    [onClose],
  );

  const close = useCallback(() => {
    onClose?.();
  }, [onClose]);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return null;
});

WebViewModal.displayName = 'WebViewModal';

export default WebViewModal;
